<template>
  <div>
    <div :class="asCard ? 'card-item' : ''">
      <div class="card-content columns is-multiline">
        <div class="column has-text-centered is-full">
          <img v-if="icon" class="icono" :src="require(`../assets/img/${icon}`)">
        </div>
        <div class="column has-text-centered is-full">
          {{ message }}
        </div>
        <div v-if="!!$slots.default" class="column has-text-centered is-full">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    asCard: { type: Boolean, default: true },
    message: String,
    icon: String
  }
};
</script>

<style scoped>
.icono {
  max-width: 250px;
}
</style>
